import { CatalogItemKind, CatalogItemOwnership } from 'fym-shared/src/smartlinks/catalog';
import { CatalogItem } from '../../../redux/api/fymAPI.types';

/**
 * How a row is labelled in the ownership column.
 *
 * `verified` is drawn but never produced: nothing can confirm a release while
 * there is no OAuth, and a green tick nobody earned is a lie. It exists so the
 * column is ready the day a connected service can answer for a release.
 */
export enum CatalogRowOwnership {
  verified = 'verified',
  claimed = 'claimed',
  featured = 'featured',
  addedByYou = 'addedByYou',
}

/** What the claim sheet carries from the picked track into the claim call. */
export interface CatalogClaimSnapshot {
  catalogTrackMaid: string;
  title: string;
  artistName: string;
  releaseType?: string;
  releaseDate?: string;
  artworkUrl?: string;
  serviceLinks?: Record<string, string>;
}

/**
 * Nothing sets `verified` today, so the ladder is: an unreleased row is the
 * artist's own typing, a featured row is somebody else's single, and everything
 * left is a claim.
 */
export function catalogRowOwnership(item: CatalogItem): CatalogRowOwnership {
  if (item.kind === CatalogItemKind.unreleased) {
    return CatalogRowOwnership.addedByYou;
  }
  if (item.ownership === CatalogItemOwnership.featured) {
    return CatalogRowOwnership.featured;
  }
  return CatalogRowOwnership.claimed;
}
